var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"text-center",attrs:{"size":100,"width":"10","color":"grey","indeterminate":""}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }